import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';

import {PrimeNGModule} from '../../core/primeNG.module';

import {SharedModule} from '../../shared/share.module';
import {ProjectResolver} from './project.resolver';
import {ProjectAccessResolver} from './project-access.resolver';
import {ProjectRoutingModule} from './project-routing.module';

import {
  ProjectAdminSettingsPage,
  ProjectChecksumPage,
  ProjectCreationPage,
  ProjectDetailsWrapperPage,
  ProjectListPage,
  ProjectMatchPage,
  ProjectMembersPage,
  ProjectPluginsPage,
  ProjectOverviewPage,
  ProjectPlayerDetailPage,
  ProjectPlayerListPage,
  ProjectSettingsPage
} from './pages';
import {ProjectNotificationsPage} from './pages/';

import {ProjectBranchListPage} from './pages/project-branch-list/project-branch-list.page';
import {ProjectBranchDetailsPage} from './pages/project-branch-details/project-branch-details.page';
import {ProjectTransactionDetailsPage} from './pages/project-transaction-details/project-transaction-details.page';
import {ProjectTransactionListPage} from './pages/project-transaction-list/project-transaction-list-page';
import {ProjectActivityDetectionPage} from './pages/project-activity/project-activity-detections/project-activity-detection.page';
import {ProjectActivityDetectionDetailsPage} from './pages/project-activity/project-activity-detection-details/project-activity-detection-details.page';
import {ProjectPlayerAccusationDetailsPage} from './pages/project-accusation-details/project-accusation-details.page';
import {ProjectActivityBuildsPage} from './pages/project-activity/project-activity-builds/project-activity-builds.page';
import {ActivityBuildSummaryComponent} from './components/activity-build-summary/activity-build-summary';
import {
  AccusationDetailsComponent,
  ActivityDetectionSummaryComponent,
  ActivityMatchSummaryComponent,
  PlayerLabelComponent,
  PlayerTrustRatingComponent, ProjectImageComponent,
  ProjectSettingComponent, WebhookHeadertableComponent, WebhookParametertableComponent
} from './components';
import {ProjectActivityMatchPage} from './pages/project-activity/project-activity-matches/project-activity-match.page';
import {Ng5SliderModule} from 'ng5-slider';
import {TelemetryDataPage} from "../telemetry/pages";
import {TelemetryEventComponent} from "../telemetry/components";
import {ProjectWebhookListPage} from './pages/project-webhook-list/project-webhook-list.page';
import {ProjectWebhookDetailsPage} from './pages/project-webhook-details/project-webhook-details.page';
import {MaxLengthComponent} from './components/max-length/max-length.component';

@NgModule({
  imports: [CommonModule, ProjectRoutingModule, HttpClientModule, FormsModule, PrimeNGModule, SharedModule, Ng5SliderModule],
  providers: [ProjectResolver, ProjectAccessResolver],
  declarations: [
    // components
    MaxLengthComponent,
    PlayerLabelComponent,
    PlayerTrustRatingComponent,
    AccusationDetailsComponent,
    ActivityDetectionSummaryComponent,
    ActivityBuildSummaryComponent,
    ProjectSettingComponent,
    WebhookParametertableComponent,
    WebhookHeadertableComponent,
    // pages
    ProjectWebhookListPage,
    ProjectWebhookDetailsPage,
    ProjectListPage,
    ProjectAdminSettingsPage,
    ProjectCreationPage,
    ProjectDetailsWrapperPage,
    ProjectOverviewPage,
    ProjectSettingsPage,
    ProjectMembersPage,
    ProjectPluginsPage,
    ProjectPlayerListPage,
    ProjectPlayerDetailPage,
    ProjectNotificationsPage,
    ProjectChecksumPage,
    ProjectBranchListPage,
    ProjectBranchDetailsPage,
    ProjectTransactionDetailsPage,
    ProjectTransactionListPage,
    ProjectActivityDetectionPage,
    ProjectActivityDetectionDetailsPage,
    ProjectActivityBuildsPage,
    ProjectPlayerAccusationDetailsPage,
    ProjectActivityMatchPage,
    ActivityMatchSummaryComponent,
    ProjectMatchPage,
    TelemetryDataPage,
    TelemetryEventComponent,
    ProjectImageComponent
  ]
})
export class ProjectModule {
}
